import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { forgotPassword } from '../api/auth';
import { authErrorMessage } from '../auth/errors';

export function ForgotPasswordPage() {
  const { t } = useTranslation(['auth', 'common', 'errors']);
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState<{ delivery: boolean } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await forgotPassword(email.trim());
      setSent({ delivery: res.delivery_available });
    } catch (err) {
      setError(authErrorMessage(t, err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page auth-page auth-sheet-page">
      <article className="auth-card auth-sheet">
        <h1>{t('auth:forgotTitle')}</h1>
        {sent ? (
          <>
            <p className="auth-success" role="status">
              {t('auth:forgotSent')}
            </p>
            {!sent.delivery ? <p className="muted-note">{t('auth:emailDeliveryOff')}</p> : null}
            <button type="button" className="btn btn-ghost btn-block" onClick={() => setSent(null)}>
              {t('auth:sendAgain')}
            </button>
          </>
        ) : (
          <form className="auth-form" onSubmit={onSubmit}>
            <p>{t('auth:forgotIntro')}</p>
            <label className="field">
              <span>{t('auth:email')}</span>
              <input
                className="field-input"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                maxLength={255}
                required
              />
            </label>
            {error ? (
              <p className="auth-error" role="alert">
                {error}
              </p>
            ) : null}
            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
              {submitting ? t('common:loading') : t('auth:forgotCta')}
            </button>
          </form>
        )}
        <p>
          <Link to="/auth/login">{t('auth:backToLogin')}</Link>
        </p>
      </article>
    </div>
  );
}
